import { render, staticRenderFns } from "./DvoranaBase.vue?vue&type=template&id=bac25aa2&scoped=true&"
import script from "./DvoranaBase.vue?vue&type=script&lang=js&"
export * from "./DvoranaBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac25aa2",
  null
  
)

export default component.exports